import { render, staticRenderFns } from "./tasksub.vue?vue&type=template&id=27a01341"
import script from "./tasksub.vue?vue&type=script&lang=js"
export * from "./tasksub.vue?vue&type=script&lang=js"
import style0 from "./tasksub.vue?vue&type=style&index=0&id=27a01341&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a01341')) {
      api.createRecord('27a01341', component.options)
    } else {
      api.reload('27a01341', component.options)
    }
    module.hot.accept("./tasksub.vue?vue&type=template&id=27a01341", function () {
      api.rerender('27a01341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/tasksub.vue"
export default component.exports